module.exports = __webpack_public_path__ + "static/media/img.7ac4c141.svg";